import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { ApiResponseBody } from '@/lib/api/api-type-helper';
export type FilterKey = Extract<keyof ApiResponseBody<'/v2/people/count', 'get'>, 'EMPLOYEE_ALUMNI' | 'BOARD_ALUMNI' | 'CONTRACTOR_ALUMNI' | 'COLLABORATOR_ALUMNI' | 'ALL_ALUMNI'>;
export const FilterKey = {
  EMPLOYEE_ALUMNI: 'EMPLOYEE_ALUMNI',
  BOARD_ALUMNI: 'BOARD_ALUMNI',
  CONTRACTOR_ALUMNI: 'CONTRACTOR_ALUMNI',
  COLLABORATOR_ALUMNI: 'COLLABORATOR_ALUMNI',
  ALL_ALUMNI: 'ALL_ALUMNI'
} as const satisfies Record<FilterKey, FilterKey>;
export const TabKey = {
  EMPLOYEE: 'Employee',
  BOARD: 'Board',
  CONTRACTOR: 'Contractor',
  COLLABORATOR: 'Collaborator',
  ALL: 'All'
} as const;
export type TabKey = EnumUnion<typeof TabKey>;